import { render, staticRenderFns } from "./InvalidVoucherList.vue?vue&type=template&id=69066504&"
import script from "./InvalidVoucherList.vue?vue&type=script&lang=js&"
export * from "./InvalidVoucherList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports